import React from "react";
import Index from "./index";
import ContactUsTable from "./ContactsTable";

const Contacts = () => {
    const { contacts, loading, history, search, setSearch, onDelete } = Index();

    return (
        <ContactUsTable
            heading="Contacts List"
            contacts={contacts}
            loading={loading}
            history={history}
            search={search}
            setSearch={setSearch}
            onDelete={onDelete}
        />
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname && prevProps.colorMode === nextProps.colorMode;
};
export default React.memo(Contacts, comparisonFn);
